"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IConnectionBoundaryDefinitionSchema = void 0;
exports.isBoundaryConnectionDefinition = isBoundaryConnectionDefinition;
const zod_1 = require("zod");
const BoundaryAssertionType_1 = require("./BoundaryAssertionType");
const RelativeSignal_1 = require("../RelativeSignal");
exports.IConnectionBoundaryDefinitionSchema = zod_1.z.object({
    type: zod_1.z.literal(BoundaryAssertionType_1.BoundaryAssertionType.Connection),
    connection: zod_1.z.array(RelativeSignal_1.RelativeSignalSchema),
    connectionImpedance: zod_1.z.number().optional(),
});
function isBoundaryConnectionDefinition(boundary) {
    return boundary.type === BoundaryAssertionType_1.BoundaryAssertionType.Connection;
}
//# sourceMappingURL=IConnectionBoundaryDefinition.js.map